import { render, staticRenderFns } from "./SimpleProfile.vue?vue&type=template&id=ac8c0d0e&"
import script from "./SimpleProfile.vue?vue&type=script&lang=js&"
export * from "./SimpleProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports